/* import __COLOCATED_TEMPLATE__ from './item-renderer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();